import React from 'react';
import * as pkg from '../../package.json';

export const Version: React.FunctionComponent = (): React.ReactElement => {
    return <span>version: {pkg.version}</span>;
};
